<template>
  <main class="main main--full-height">
    <ui-module-loader      
      v-if="orgLoading === 'loading' || orgLoading === 'initial'"
      :messages="[
        'Please give us a moment'
      ]"
      key="loader"
    />
    <div class="group" v-if="orgLoading === 'done'" :key="orgLoading">
      <div class="grid grid--auth">
        
        <div class="grid__item grid__item--2">
          <ui-auth id="login" />

          <p v-if="hideVerifiyForm" class="mt fsi">
            Don't have an account? <router-link to="/">Explore</router-link> these resources to see what's right for you. 
          </p>

          <ui-auth
            v-if="!hideVerifiyForm"
            id="verify"
            class="pat2"
            :success="success"
            :send-verification="resendVerification"
            :verify-text="resendEmailCodeText"
          />

          <transition name="button" mode="out-in">
            <p v-if="resendVerificationResponse" class="p pat mt0">
              {{ resendVerificationResponse }}
            </p>
          </transition>

          <p v-show="resendErrorMessage" class="c-error mt mb">
            {{ resendErrorMessage }}
          </p>
        </div>
        <div class="grid__item grid__item--2">
          <img :src="image" width="100%" alt="" >
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Ui
import UiAuth from 'components/Auth';
import UiModuleLoader from 'components/ModuleLoader';

// Transitions

import illustration from 'images/home/login.png';

// Images
const images = {
  illustration,
};

// Export
export default {
  name: 'view-login',

  // Components
  components: {
    UiAuth,
    UiModuleLoader,
  },

  // Data
  data() {
    return {
      resendVerificationResponse: null,
      resendEmailCodeText: 'Resend code',
      resendErrorMessage: null,
      image: images.illustration,
    };
  },

  beforeRouteEnter(to, from, next) {
    if (from.path === '/password/forgot' && localStorage.resetCheck) {
      to.meta.messages = [
        'All set. We’ve updated your password.',
        'Please login with your new password.',
      ];
      localStorage.removeItem('resetCheck');
    }
    next();
  },

  beforeRouteLeave(to, from, next) {
    delete from.meta.messages;
    next();
  },

  // Computed
  computed: {
    ...mapGetters('forms', ['getFormView', 'getForm', 'getField']),
    ...mapGetters('auth', ['verified']),
    ...mapGetters('app', ['org', 'orgLoading']),

    hideVerifiyForm() {
      if (this.verified === 'initial' || this.verified === true) {
        return true;
      }
      return false;
    },
  },

  // Methods
  methods: {
    ...mapActions('auth', ['requestResendVerification', 'requestLogin']),
    ...mapActions('messaging', ['requestUnreadCount']),

    resendVerification() {
      const model = this.getFormView('auth-login');

      if (model && model.email) {
        this.resendEmailCodeText = 'Sending email code...';

        this.requestResendVerification({
          email: model.email,
        })
          .then(response => {
            this.resendVerificationResponse =
              'Further instructions will be sent to your email address.';

            setTimeout(() => {
              this.resendEmailCodeText = 'Resend code';
            }, 3000);

            return response;
          })
          .catch(error => {
            console.error(error);

            this.resendErrorMessage =
              error.data.errors.length > 0 && error.data.errors[0].message;

            setTimeout(() => {
              this.resendEmailCodeText = 'Resend code';
            }, 3000);
          });
      }
    },

    success() {
      setTimeout(() => {
        this.requestLogin({
          email: this.getFormView('auth-login').email,
          password: this.getFormView('auth-login').password,
        });
      }, 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Login.vue?5fc59c64